const locale = navigator.languages[0] || navigator.language;

export const currencyFormat = (currency: string | undefined, val: number) => {
  if (Number.isNaN(val)) {
    throw new Error(`Invalid currency value`);
  }
  return val === 0
    ? '-'
    : Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: Math.floor(val) === val ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(val);
};
